import { CALL_API } from '../../middleware/api';

export const SEARCH_USERS_REQUEST = 'SEARCH_USERS_REQUEST';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
export const SEARCH_USERS_FAILURE = 'SEARCH_USERS_FAILURE';

export const GET_USERS_GROUPS_REQUEST = 'GET_USERS_GROUPS_REQUEST';
export const GET_USERS_GROUPS_SUCCESS = 'GET_USERS_GROUPS_SUCCESS';
export const GET_USERS_GROUPS_FAILURE = 'GET_USERS_GROUPS_FAILURE';

export const GET_USER_PATIENT_INFO_REQUEST = 'GET_USER_PATIENT_INFO_REQUEST';
export const GET_USER_PATIENT_INFO_SUCCESS = 'GET_USER_PATIENT_INFO_SUCCESS';
export const GET_USER_PATIENT_INFO_FAILURE = 'GET_USER_PATIENT_INFO_FAILURE';

export const UPDATE_USERS_GROUPS_REQUEST = 'UPDATE_USERS_GROUPS_REQUEST';
export const UPDATE_USERS_GROUPS_SUCCESS = 'UPDATE_USERS_GROUPS_SUCCESS';
export const UPDATE_USERS_GROUPS_FAILURE = 'UPDATE_USERS_GROUPS_FAILURE';

export const TOGGLE_USER_FLAG_REQUEST = 'TOGGLE_USER_FLAG_REQUEST';
export const TOGGLE_USER_FLAG_SUCCESS = 'TOGGLE_USER_FLAG_SUCCESS';
export const TOGGLE_USER_FLAG_FAILURE = 'TOGGLE_USER_FLAG_FAILURE';

export const CLEAR_USER_ACCESS_CODE_REQUEST = 'CLEAR_USER_ACCESS_CODE_REQUEST';
export const CLEAR_USER_ACCESS_CODE_SUCCESS = 'CLEAR_USER_ACCESS_CODE_SUCCESS';
export const CLEAR_USER_ACCESS_CODE_FAILURE = 'CLEAR_USER_ACCESS_CODE_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const REMOVE_SIMPLIFED_PATIENT_ID_REQUEST = 'REMOVE_SIMPLIFED_PATIENT_ID_REQUEST';
export const REMOVE_SIMPLIFED_PATIENT_ID_SUCCESS = 'REMOVE_SIMPLIFED_PATIENT_ID_SUCCESS';
export const REMOVE_SIMPLIFED_PATIENT_ID_FAILURE = 'REMOVE_SIMPLIFED_PATIENT_ID_FAILURE';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const searchUsers = ({ limit = 25, offset = 0, firstName, lastName, email, firebaseId, sortBy = 'createdDate', sortDirection = 'DESC' } = {}) => {
  const params = { limit, offset, sortBy, sortDirection };
  if (firstName) params.firstName = firstName;
  if (lastName) params.lastName = lastName;
  if (email) params.email = email;
  if (firebaseId) params.firebaseId = firebaseId;

  const queryString = new URLSearchParams(params ).toString();

  return {
    [CALL_API]: {
      types: [SEARCH_USERS_REQUEST, SEARCH_USERS_SUCCESS, SEARCH_USERS_FAILURE],
      authenticated: true,
      endpoint: `users/search?${queryString}`,
      method: 'GET',
    },
  };
};

export const getUserGroups = (userId) => {
  return {
    [CALL_API]: {
      types: [GET_USERS_GROUPS_REQUEST, GET_USERS_GROUPS_SUCCESS, GET_USERS_GROUPS_FAILURE],
      authenticated: true,
      endpoint: `users/${userId}/groups`,
      method: 'GET',
      actionMetadata: {
        userId,
      },
    },
  };
};

export const getUserPatientInfo = (patientId) => {
  return {
    [CALL_API]: {
      types: [GET_USER_PATIENT_INFO_REQUEST, GET_USER_PATIENT_INFO_SUCCESS, GET_USER_PATIENT_INFO_FAILURE],
      authenticated: true,
      endpoint: `simplifed/patient/${patientId}`,
      method: 'GET',
      actionMetadata: {
        patientId,
      },
    },
  };
};

// flagName is a string 'canDebug' 
export const toggleUserFlag = (userId, flagName) => {
  return {
    [CALL_API]: {
      types: [TOGGLE_USER_FLAG_REQUEST, TOGGLE_USER_FLAG_SUCCESS, TOGGLE_USER_FLAG_FAILURE],
      authenticated: true,
      endpoint: `users/${userId}/toggle/${flagName}`,
      method: 'POST',
      actionMetadata: {
        userId,
        flagName,
      },
    },
  };
};

export const updateUserGroups = (userId, userGroups) => {
  return {
    [CALL_API]: {
      types: [UPDATE_USERS_GROUPS_REQUEST, UPDATE_USERS_GROUPS_SUCCESS, UPDATE_USERS_GROUPS_FAILURE],
      authenticated: true,
      endpoint: `users/${userId}/groups`,
      method: 'POST',
      payload: {
        userGroups,
      },
      actionMetadata: {
        userId,
        userGroups,
      },
    },
  };
};

export const clearUserAccessCodes = userId => {
  return {
    [CALL_API]: {
      types: [CLEAR_USER_ACCESS_CODE_REQUEST, CLEAR_USER_ACCESS_CODE_SUCCESS, CLEAR_USER_ACCESS_CODE_FAILURE],
      authenticated: true,
      endpoint: `users/${userId}/accessCodes`,
      method: 'DELETE',
      actionMetadata: {
        userId,
      },
    },
  };
};

export const deleteUser = userId => {
  return {
    [CALL_API]: {
      types: [DELETE_USER_REQUEST, DELETE_USER_SUCCESS, DELETE_USER_FAILURE],
      authenticated: true,
      endpoint: `users/${userId}`,
      method: 'DELETE',
      actionMetadata: {
        userId,
      },
    },
  };
};

export const getUser = (userId) => ({
  [CALL_API]: {
    types: [GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_FAILURE],
    authenticated: true,
    endpoint: `users/${userId}`,
    method: 'GET',
  },
});

export const removeSimplifedPatientId = (userId) => {
  return {
    [CALL_API]: {
      types: [REMOVE_SIMPLIFED_PATIENT_ID_REQUEST, REMOVE_SIMPLIFED_PATIENT_ID_SUCCESS, REMOVE_SIMPLIFED_PATIENT_ID_FAILURE],
      authenticated: true,
      endpoint: `users/${userId}`,
      method: 'PATCH',
      payload: {
        simplifedPatientId: null,
      },
      actionMetadata: {
        userId,
      },
    },
  };
};